import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M 12,0 C 9.79086,0 8,1.79086 8,4 v 9 c 0,2.2091 1.79086,4 4,4 2.2091,0 4,-1.7909 4,-4 V 4 C 16,1.79086 14.2091,0 12,0 Z m 0,15 c -1.1046,0 -2,-0.8954 -2,-2 V 4 c 0,-1.10457 0.8954,-2 2,-2 1.1046,0 2,0.89543 2,2 v 9 c 0,1.1046 -0.8954,2 -2,2 z M3 10C3.55228 10 4 10.4477 4 11C4 15.4183 7.58172 19 12 19C16.4183 19 20 15.4183 20 11C20 10.4477 20.4477 10 21 10C21.5523 10 22 10.4477 22 11C22 16.1858 18.0527 20.4496 12.9988 20.9507C12.9996 20.9671 13 20.9835 13 21V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V21C11 20.9835 11.0004 20.9671 11.0012 20.9507C5.9473 20.4496 2 16.1858 2 11C2 10.4477 2.44772 10 3 10Z"
  }));
});
var MultimediaVoice = AbstractIcon.withComponent(Icon);
MultimediaVoice.displayName = 'MultimediaVoice';
export default MultimediaVoice;